import { BrowserModule } from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ImportFileComponent } from './import-file/import-file.component';
import { MainComponent } from './main/main.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DisplayImagesFromFileComponent } from './display-images-from-file/display-images-from-file.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import { ImageFromFileComponent } from './image-from-file/image-from-file.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { DialogFileGettingReadyComponent } from './dialog-file-getting-ready/dialog-file-getting-ready.component';
import { DialogStartComponent } from './dialog-start/dialog-start.component';
import { MakeOerComponent } from './make-oer/make-oer.component';
// tslint:disable-next-line:max-line-length
import { DialogWarningImagesRatioMismatchComponent } from './dialog-warning-images-ratio-mismatch/dialog-warning-images-ratio-mismatch.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { ImageFromOnlineSearchComponent } from './image-from-online-search/image-from-online-search.component';
import { DialogEditImageComponent } from './compare-images/dialog-edit-image/dialog-edit-image.component';
import { SearchDatabaseForOccurencesComponent } from './search-database-for-occurences/search-database-for-occurences.component';
import { DialogSuggestionsFromDatabaseComponent } from './dialog-suggestions-from-database/dialog-suggestions-from-database.component';
import {CompareImagesModule} from './compare-images/compare-images.module';
import {HeaderModule} from './header/header.module';
import {LoadingSpinnerModule} from './loading-spinner/loading-spinner.module';
import {ImageGalleryModule} from './image-gallery/image-gallery.module';
import {BottomSheetGenericComponent} from './bottom-sheet-generic/bottom-sheet-generic.component';
import {BottomSheetGenericModule} from './bottom-sheet-generic/bottom-sheet-generic.module';
import {SearchExternalApiModule} from './search-external-api/search-external-api.module';
import { OerFormularComponent } from './oer-formular/oer-formular.component';
import { ReplaceByImageFromMachineComponent } from './replace-by-image-from-machine/replace-by-image-from-machine.component';
import { DialogAskForFeedbackComponent } from './dialog-ask-for-feedback/dialog-ask-for-feedback.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ExcludeFromOverallLicenseComponent } from './exclude-from-overall-license/exclude-from-overall-license.component';
import {AdminAreaModule} from './admin-area/admin-area.module'
import { FormsModule } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import {MatRadioModule} from '@angular/material/radio';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DialogConfirmationComponent } from './dialog-confirmation/dialog-confirmation.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ActionViewerComponent } from './action-viewer/action-viewer.component';
import { UserConsentBottomSheet } from './user-consent/user-consent.component';
import { DialogGenerateAIImagesComponent } from './dialog-generate-ai-images/dialog-generate-ai-images.component';
import { DialogTermsAndConditionsComponent } from './dialog-terms-and-conditions/dialog-terms-and-conditions.component';
import { ModuleSelectorComponent } from './module-selector/module-selector.component';
import { TextModuleComponent } from './text-module/text-module.component';
import { VideoModuleComponent } from './video-module/video-module.component';
import { RouterModule } from '@angular/router';
import { DialogSuggestionsFromDatabaseModule } from './dialog-suggestions-from-database/dialog-suggestions-from-database.module';
import { DialogStartVideoComponent } from './dialog-start-video/dialog-start-video.component';
import { DialogStartTextComponent } from './dialog-start-text/dialog-start-text.component';
import { ModuleTrackerService } from './services/module-tracker.service';
import { NavigationHistoryService } from './services/navigation-history.service';
import { ColabVideoService } from './services/colab-video.service';
import { ChatHistoryService } from './services/chat-history.service';
import { SafePipe } from './shared/pipes/safe.pipe';
import { GuideDialogComponent, ChunkSelectionDialogComponent } from './text-module/text-module.component';
import { DialogGradioConfigComponent } from './dialog-gradio-config/dialog-gradio-config.component';
import { GradioConfigService } from './services/gradio-config.service';

@NgModule({
  declarations: [
    AppComponent,
    ImportFileComponent,
    MainComponent,
    DisplayImagesFromFileComponent,
    ImageFromFileComponent,
    MainHeaderComponent,
    DialogFileGettingReadyComponent,
    DialogStartComponent,
    MakeOerComponent,
    DialogWarningImagesRatioMismatchComponent,
    ImageFromOnlineSearchComponent,
    SearchDatabaseForOccurencesComponent,
    OerFormularComponent,
    ReplaceByImageFromMachineComponent,
    DialogAskForFeedbackComponent,
    FeedbackComponent,
    ExcludeFromOverallLicenseComponent,
    DialogConfirmationComponent,
    ActionViewerComponent,
    UserConsentBottomSheet,
    DialogGenerateAIImagesComponent,
    DialogTermsAndConditionsComponent,
    ModuleSelectorComponent,
    TextModuleComponent,
    VideoModuleComponent,
    DialogStartVideoComponent,
    DialogStartTextComponent,
    SafePipe,
    GuideDialogComponent,
    ChunkSelectionDialogComponent,
    DialogGradioConfigComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ScrollingModule,
    CompareImagesModule,
    HeaderModule,
    LoadingSpinnerModule,
    ImageGalleryModule,
    BottomSheetGenericModule,
    SearchExternalApiModule,
    DialogSuggestionsFromDatabaseModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatButtonToggleModule,
    ClipboardModule,
    AdminAreaModule,
    RouterModule
  ],
  providers: [
    ModuleTrackerService,
    NavigationHistoryService,
    ColabVideoService,
    ChatHistoryService,
    GradioConfigService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
